var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddTaskPlusMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x94\xD0\xBE\xD0\xB1\xD0\xB0\xD0\xB2\xD0\xB8\xD1\x82\xD1\x8C \xD0\xB7\xD0\xB0\xD0\xB4\xD0\xB0\xD1\x87\xD1\x83 - active"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M10.9238 4.4974C10.9238 4.03716 10.5507 3.66406 10.0905 3.66406C9.63026 3.66406 9.25716 4.03716 9.25716 4.4974V9.4974H4.25716C3.79692 9.4974 3.42383 9.87049 3.42383 10.3307C3.42383 10.791 3.79692 11.1641 4.25716 11.1641H9.25716V16.1641C9.25716 16.6243 9.63026 16.9974 10.0905 16.9974C10.5507 16.9974 10.9238 16.6243 10.9238 16.1641V11.1641H15.9238C16.3841 11.1641 16.7572 10.791 16.7572 10.3307C16.7572 9.87049 16.3841 9.4974 15.9238 9.4974H10.9238V4.4974Z",
    fill: "#5932EA"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTaskPlusMobile);
export default __webpack_public_path__ + "static/media/add-task-plus__mobile.497d1b22cce33e3dadb7c7cc721ee800.svg";
export { ForwardRef as ReactComponent };